import Toast from '@ui/components/Toast';
import Button from '@ui/components/Button';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 600px;
  z-index: 999999;
`;

const ImpersonatedWarning = ({ onExistImpersonating, impersonatedAs }) => (
  <Wrapper>
    <Toast variant="warning">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          You are currently impersonating the account: <b>{impersonatedAs}</b>. All actions will be
          performed as this user.
        </div>

        <Button onClick={onExistImpersonating} iconName="close">
          Exit
        </Button>
      </div>
    </Toast>
  </Wrapper>
);

export default ImpersonatedWarning;
